// src/constants/Roles.ts
enum Roles {
  TEACHER = 'teacher',
  STUDENT = 'student',
}

export { Roles };
